"use client";

import { useState } from "react";
import { CountryCombobox } from "@/components/country-combobox";
import { useMessages } from "@/lib/i18n/client";
import messages from "./viva-cine-region-picker.i18n";

// Viva Cine sigue el país del selector global; el catálogo de otro país
// queda a mano pero discreto, detrás de un enlace.
export function VivaCineRegionPicker({
  label,
  value,
  onChange,
}: {
  label: string;
  value: string;
  onChange: (region: string) => void;
}) {
  const t = useMessages(messages);
  const [open, setOpen] = useState(false);

  return (
    <div className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
      <span>{label}</span>
      {open ? (
        <CountryCombobox value={value} onChange={onChange} />
      ) : (
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="underline-offset-2 hover:text-foreground hover:underline"
        >
          {t.otherCountry}
        </button>
      )}
    </div>
  );
}
